module.exports = __webpack_public_path__ + "static/img/cloud.68c2cd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cloud.png
// module id = 5Ax4
// module chunks = 9